import React, {useState, useEffect, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyMenuView from '../../views/fullBodyMenuView';
import {useMenu} from '../../../hooks/useMenu';
import ChannelConfig from './channel-config';
import SetModbus from './set-modbusTN';
import SensorParameters from './sensor';

function ChannelSelection() {
  const {onComponent} = useMenu();
  const channelItem = [
    {
      id: 1,
      name: 'Channel A',
      children: [
        {
          id: 11,
          name: 'Milliamp Output 1',
          children: [
            {
              id: 111,
              name: 'Active',
              children: [
                {id: 1111, name: 'Mass Flow Rate'},
                {id: 1112, name: 'Volume Flow Rate'},
                {id: 1113, name: 'Drive Gain'},
                {id: 1114, name: 'GSV Flow Rate'},
                {id: 1115, name: 'Velocity'},
                {id: 1116, name: 'Temperature'},
                {id: 1117, name: 'Density'},
                {id: 1118, name: 'External Pressure'},
                {id: 1119, name: 'External Temperature'},
                {id: 1120, name: 'External Density'},
                {id: 1121, name: 'FI Flow Rate'},
                {id: 1122, name: 'PV_PG_FLOW_SEVERITY'},
                {id: 1123, name: 'Referred Density'},
                {id: 1124, name: 'Referred Volume Flow'},
                {id: 1125, name: 'Avg. Line Density'},
                {id: 1126, name: 'Avg. Temperature'},
                {id: 1127, name: 'Referred Density'},
                {id: 1128, name: 'Specific Gravity'},
                {id: 1129, name: 'Standard Vol Flow'},
                {id: 1130, name: 'Net Mass Flow'},
                {id: 1131, name: 'Net Volume Flow Rate'},
                {id: 1132, name: 'Concentration'},
                {id: 1133, name: '% of Fill'},
                {id: 1134, name: 'PV_FUEL_DIFF_MASS_FLOW'},
                {id: 1135, name: 'PV_NET_FLOW_OIL_AT_LINE'},
                {id: 1136, name: 'PV_WATERCUT_AT_LINE'},
                {id: 1137, name: 'PV_EXT_WATERCUT'},
                {id: 1138, name: 'PV_NET_FLOW_WATER_AT_LINE'},
                {id: 1139, name: 'PV_NET_FLOW_OIL_AT_REF'},
                {id: 1140, name: 'PV_WATERCUT_AT_REF'},
                {id: 1141, name: 'PV_NET_FLOW_WATER_AT_REF'},
                {id: 1142, name: 'PV_GAS_VOID_FRACTION'},
                {id: 1143, name: 'PV_UNREM_MASS_FLOW'},
                {id: 1144, name: 'PV_UNREM_VOL_FLOW'},
                {id: 1145, name: 'PV_UNREM_DENSITY'},
                {id: 1146, name: 'PV_DEN_CALORIFIC_VALUE'},
                {id: 1147, name: 'PV_DEN_ENERGY_FLOW'},
                {id: 1148, name: 'PV_NOC_UNC_GROSS_FLOW'},
                {id: 1149, name: 'PV_NOC_UNC_GROSS_FLOW'},
                {id: 1150, name: 'PV_NOC_AVE_UNC_OIL_FLOW'},
                {id: 1151, name: 'PV_NOC_AVE_UNC_WATER_CUT'},
                {id: 1152, name: 'PV_NOC_AVE_UNC_GROSS_FLOW'},
                {id: 1153, name: 'PV_NOC_AVE_UNC_WATER_FLOW'},
                {id: 1154, name: 'PV_NOC_AVE_UNC_BACK_FLOW'},
                {id: 1155, name: 'PV_NOC_AVE_NET_OIL_FLOW'},
                {id: 1156, name: 'PV_NOC_AVE_NET_WATER_CUT'},
                {id: 1157, name: 'PV_NOC_AVE_NET_GROSS_FLOW'},
                {id: 1158, name: 'PV_NOC_AVE_NET_WATER_FLOW'},
                {id: 1159, name: 'PV_NOC_AVE_DENSITY'},
                {id: 1160, name: 'PV_NOC_AVE_TEMPERATURE'},
                {id: 1161, name: 'PV_NOC_AVE_MASS_FLOW'},
                {id: 1162, name: 'PV_TMR_LIQUID_FLOW'},
              ],
            },
            {id: 112, name: 'Passive'},
          ],
        },
      ],
    },
    {
      id: 2,
      name: 'Channel B',
      children: [
        {id: 21, name: 'Milliamp Output 2'},
        {id: 22, name: 'Frequency Output 2'},
        {id: 23, name: 'Discrete Output 1'},
        {id: 24, name: 'None'},
      ],
    },
    {
      id: 3,
      name: 'Channel C',
      children: [
        {id: 31, name: 'Milliamp Output 3'},
        {id: 32, name: 'Milliamp Output 3'},
        {id: 33, name: 'Frequency Output 1'},
        {id: 34, name: 'Discrete Output 1'},
        {id: 35, name: 'Discrete Output 2'},
        {id: 36, name: 'Discrete Input 1'},
        {id: 37, name: 'None'},
      ],
    },
    {
      id: 4,
      name: 'Channel D',
      children: [
        {id: 41, name: 'Frequency Output 2'},
        {id: 42, name: 'Discrete Output 2'},
        {id: 43, name: 'Discrete Output 3'},
        {id: 44, name: 'Discrete Input 2'},
        {id: 45, name: 'Milliamp Input 1'},
        {id: 46, name: 'Frequency Input'},
        {id: 47, name: 'None'},
      ],
    },
    {id: 5, name: 'Channel E', component: <SetModbus />},
    {id: 6, name: 'Finished', component: <SensorParameters />},
  ];

  // const leftPress = useKeyPress('ArrowLeft');

  // const onLeft = useCallback(() => {
  //   onComponent(<ChannelConfig />);
  // }, []);

  // useEffect(() => {
  //   if (!leftPress) return;

  //   // onComponent(<ChannelConfig />);
  // }, [leftPress]);

  return (
    <FullBodyMenuView
      title="Channel Configuration"
      menuItems={channelItem}
      isMenuDisabled
      onLeftCallback={() => onComponent(<ChannelConfig />)}
    />
  );
}

export default ChannelSelection;
